import { render, staticRenderFns } from "./new_pswd.vue?vue&type=template&id=3b9ffede&scoped=true&"
import script from "./new_pswd.vue?vue&type=script&lang=js&"
export * from "./new_pswd.vue?vue&type=script&lang=js&"
import style0 from "./new_pswd.vue?vue&type=style&index=0&id=3b9ffede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9ffede",
  null
  
)

export default component.exports